/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-09 14:54:16
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-26 10:28:21
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/column.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'';

import { tr } from 'date-fns/locale';

function getColums(that) {
	const isDr = that.isDr;
	const { platformId } = that.search;
	let arr = [
		{
			key: 'userInfo',
			label: '员工信息',
			type: () => import('./tableCells/stallInfo.vue'),
			minWidth: '180',
			show: true,
			fixed: 'left',
			disabled: true,
			baseColums: true,
		},
		{
			key: 'totalAmount',
			label: '支付金额',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内，团长订单累计已支付的GMV',
			sortable: 'totalAmount',
			disabled: true,
			baseColums: true,
		},
		{
			key: 'totalOrder',
			label: '支付订单量',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内，所有团长订单累计已支付的订单',
			sortable: 'totalOrder',
			baseColums: true,
		},
		{
			key: 'settleAmount',
			label: '结算金额',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内，团长订单累计已结算的GMV',
			sortable: 'settleAmount',
			baseColums: true,
		},

		{
			key: 'settleOrder',
			label: '结算订单量',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内，团长订单累计已结算的订单量',
			sortable: 'settleOrder',
			baseColums: true,
		},
		{
			key: 'partnerEstimatedCommission',
			label: '预估到手服务费',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: true,
			helpDesc1: '预估服务费收入-预估服务费支出，预估可提取的金额',
			sortable: 'partnerEstimatedCommission',
			baseColums: true,
			// baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'partnerRealCommission',
			label: '实际到手服务费',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: true,
			helpDesc1: '为真实可提取的金额。订单未到达结算状态时，实际到手服务费无数据',
			sortable: 'partnerRealCommission',
			baseColums: true,
			// baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'incomeEstimatedCommission',
			label: '预估服务费收入',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内商家提供的预估服务费总计，包括已结算服务费、未结算服务费（未扣除技术服务费）',
			sortable: 'incomeEstimatedCommission',
			baseColums: true,
		},
		{
			key: 'incomeRealCommission',
			label: '实际服务费收入',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内商家提供的已结算服务费总计（已扣除技术服务费）',
			sortable: 'incomeRealCommission',
			baseColums: true,
		},
		{
			key: 'disburseEstimatedCommission',
			label: '预估服务费支出',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内给二级团长分成的预估服务费支出',
			sortable: 'disburseEstimatedCommission',
			baseColums: true,
			// baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'disburseRealCommission',
			label: '实际服务费支出',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: true,
			helpDesc1: '所选时间范围内给二级团长分成的已结算服务费支出',
			sortable: 'disburseRealCommission',
			baseColums: true,
			// baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'serviceEstimatedCommission',
			label: '预估技术服务费',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: true,
			helpDesc1: '为官方收取的技术服务费，若发生退货退款，该费用将不收取',
			sortable: 'serviceEstimatedCommission',
			baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'serviceRealCommission',
			label: '实际技术服务费',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: !that.$isSp(platformId),
			helpDesc1: '为已结算状态订单，官方平台实际收取的技术服务费',
			sortable: 'serviceRealCommission',
			baseColums: that.$isPlatOr(platformId, ['ALL', 'Dy', 'Ks']),
		},
		{
			key: 'estimatedCommission',
			label: `预估${isDr ? '商务' : '招商'}提成`,
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			check: false,
			show: true,
			helpDesc1: '所选时间范围内团长所有支付订单的提成，已扣除官方平台技术服务费（若有）',
			sortable: 'estimatedCommission',
			baseColums: true,
		},
		{
			key: 'realCommission',
			label: `结算${isDr ? '商务' : '招商'}提成`,
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: true,
			minWidth: '180',
			helpNum: 1,
			show: true,
			helpDesc1: '所选时间范围内已结算团长订单的提成，已扣除官方平台技术服务费（若有）',
			sortable: 'realCommission',
			baseColums: true,
		},
		{
			key: 'totalOrderAnchor',
			label: '出单达人数',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '180',
			helpNum: 1,
			show: false,
			helpDesc1: '所选时间段内有订单产生的达人数',
			sortable: 'totalOrderAnchor',
			baseColums: isDr,
		},
		{
			key: 'totalOrderProduct',
			label: '出单商品数',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '180',
			helpNum: 1,
			show: false,
			helpDesc1: '所选时间范围内有订单产生的商品数',
			sortable: 'totalOrderProduct',
			baseColums: !isDr,
		},
		{
			key: 'newClues',
			label: '线索数',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'newClues',
			baseColums: isDr,
		},
		{
			key: 'newBuild',
			label: '建联达人',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'newBuild',
			baseColums: isDr,
		},
		{
			key: 'applyNum',
			label: '申样达人',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'applyNum',
			baseColums: isDr,
		},
		{
			key: 'expertNum',
			label: '成交达人',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'expertNum',
			baseColums: isDr,
		},
		{
			key: 'expertNewNum',
			label: '新成交达人',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'expertNewNum',
			baseColums: isDr,
		},
		{
			key: 'noLiveProduct',
			label: '待开播商品',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'noLiveProduct',
			baseColums: isDr,
		},
		{
			key: 'liveProduct',
			label: '直播商品',
			type: () => import('./tableCells/priceCell.vue'),
			showPriceTag: false,
			minWidth: '120',
			show: true,
			sortable: 'liveProduct',
			baseColums: isDr,
		},
	];
	return arr;
}

export default getColums;
